const NPI_BASE = 'https://npiregistry.cms.hhs.gov/api';

function toTitleCase(str) {
  return (str || '').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Searches individual providers via our Cloudflare proxy → live NPPES registry.
 * NPPES does not set CORS headers so we cannot call it directly from the browser.
 */
export async function searchDoctors(firstName, lastName, state = '') {
  if (!lastName.trim()) return [];

  const params = new URLSearchParams({ last_name: lastName.trim(), limit: '200' });
  if (firstName.trim()) params.set('first_name', firstName.trim());
  if (state) params.set('state', state);

  const res = await fetch(`/api/doctor-search?${params}`);
  if (!res.ok) return [];
  return res.json();
}

/**
 * Fetches pharmacies near a given ZIP code (or state fallback) from the NPI Registry.
 * Returns location-specific results (e.g. "Walgreens #5832 at 123 Main St").
 */
export async function searchNearbyPharmacies(zip, state) {
  const params = new URLSearchParams({
    version: '2.1',
    enumeration_type: 'NPI-2',
    taxonomy_description: 'pharmacy',
    limit: 25,
  });

  if (zip)        params.set('postal_code', zip);
  else if (state) params.set('state', state);
  else            return [];

  const res = await fetch(`${NPI_BASE}/?${params}`);
  if (!res.ok) return [];
  const data = await res.json();

  return (data.results || []).map(r => {
    const addr = (r.addresses || []).find(a => a.address_purpose === 'LOCATION')
      || r.addresses?.[0]
      || {};
    return {
      name: toTitleCase(r.basic?.organization_name || ''),
      address: toTitleCase(addr.address_1 || ''),
      city: toTitleCase(addr.city || ''),
      state: addr.state || '',
    };
  }).filter(p => p.name);
}
